import styles from "./winter-wonderland-background.module.less";

const WinterWonderland = ({ showTopGradient = undefined }) => {
  return (
    <div className={styles.wrapper}>
      {showTopGradient && <div className={styles.topGradient}></div>}
      <div className={styles.topSpotWrapper}>
        <TopSpotlight />
      </div>
      <div className={styles.middleSpotWrapper}>
        <MiddleSpotlight />
      </div>
      <div className={styles.bottomSpotWrapper}>
        <BottomSpotlight />
      </div>
      <div className={styles.bottomGradient}></div>
    </div>
  );
};

const TopSpotlight = () => {
  return <img src={"/background-images/winter-wonderland/top spotlight.png"} alt={"Winter spotlight"} />;
};

const MiddleSpotlight = () => {
  return <img src={"/background-images/winter-wonderland/middle spotlight gradient.png"} alt={"Winter spotlight"} />;
};

const BottomSpotlight = () => {
  return <img src={"/background-images/winter-wonderland/bottom spotlight gradient.png"} alt={"Winter spotlight"} />;
};

export default WinterWonderland;
